import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
var Box = forwardRef(function (_a, ref) {
    var width = _a.width, height = _a.height, row = _a.row, col = _a.col, padding = _a.padding, margin = _a.margin, wrap = _a.wrap, minHeight = _a.minHeight, flex = _a.flex, children = _a.children, center = _a.center, gap = _a.gap, overflow = _a.overflow, reverse = _a.reverse, justifyContent = _a.justifyContent, alignItems = _a.alignItems, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
    var flexDirection = row ? "row" : col ? "column" : "row";
    if (reverse)
        flexDirection += "-reverse";
    if (center)
        justifyContent = "center";
    if (center)
        alignItems = "center";
    return (_jsx("div", { ref: ref, style: {
            width: width,
            height: height,
            padding: padding,
            margin: margin,
            minHeight: minHeight,
            flex: flex,
            display: "flex",
            flexWrap: wrap ? "wrap" : "nowrap",
            whiteSpace: wrap !== false ? "normal" : "nowrap",
            alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : "flex-start",
            justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start",
            flexDirection: flexDirection,
            gap: gap,
            overflow: overflow,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            position: "relative",
            boxSizing: "border-box",
            pointerEvents: "auto",
        }, children: children }));
});
export default Box;
